import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    app_name: "ATTENDIO",
    tagline: "Attendance · Leave · Reports",
    login: "Log in",
    logout: "Log out",
    email: "Email",
    password: "Password",
    sign_in: "Sign in",
    dashboard: "Dashboard",
    kiosk: "Kiosk",
    attendance: "My attendance",
    my_status: "My status",
    monitor: "Monitor",
    leave: "Leave",
    approvals: "Approvals",
    employees: "Employees",
    reports: "Reports",
    audit: "Audit log",
    settings: "Settings",
    monthly_card: "Monthly card",
    monthly_card_title: "Monthly card",
    anomalies: "Anomalies",
    anomalies_title: "Anomalies",
    mc_total: "Total",
    mc_flags: "Flags",
    mc_download_all: "Download all (PDF)",
    mc_download_single: "Download this employee's PDF",
    mc_hint_click_cell: "Click a cell to edit the day",
    mc_group_entry: "Group entry",
    mc_group_title: "Bulk apply hours or leave",
    mc_group_targets: "Target employees",
    mc_group_apply: "Apply to selected",
    mc_group_applied: "Rows applied",
    mc_group_pick_target: "Pick a team or at least one employee",
    mc_whole_team_hint: "Will apply to the whole team (no individual selection)",
    mc_include_weekends: "Also include weekends and holidays",
    mc_edit_day: "Edit day",
    mc_worked_h: "Worked h",
    mc_clear_override: "Clear override",
    mc_saved: "Saved",
    mc_override_tag: "Manual override",
    mc_edit_times: "Enter arrival/departure (HH:MM)",
    mc_edit_times_hint: "Fill both to log a real timestamped shift. Overrides the hours fields below.",
    mc_edit_or_hours: "— or just enter hours —",
    prihod: "Arrival",
    odhod: "Departure",
    mode_desktop_label: "Office",
    mode_kiosk_label: "Entrance tablet",
    mode_pwa_label: "Phone",
    app_mode: "App mode",
    app_mode_pick: "Pick device mode",
    mode_pwa_install: "Install Attendio to your home screen",
    mode_pwa_installed_or_unsupported: "Already installed, or browser does not support install prompt",
    mode_pwa_fallback_hint: "iPhone / Safari: tap the Share button then 'Add to Home Screen'. Android / Chrome: tap the ⋮ menu then 'Install app' or 'Add to Home Screen'.",
    all_teams: "All teams",
    note: "Note",
    start_date: "Start date",
    end_date: "End date",
    select_all: "Select all",
    deselect_all: "Deselect all",
    selected: "selected",
    emp_reset_email_tip: "Send password reset email",
    emp_reset_temp_tip: "Generate temporary password",
    emp_reset_email_confirm: "Send a password reset email to this employee?",
    emp_reset_email_sent: "Reset email sent",
    emp_reset_link_generated: "Reset link generated (email sending disabled)",
    emp_reset_temp_confirm: "Generate a temporary password for this employee?",
    emp_temp_password_title: "Temporary password",
    emp_temp_password_hint: "Copy this and share with the employee. They can log in now with it.",
    legend: "Legend",
    office: "Office",
    anomaly: "Anomaly",
    employee: "Employee",
    date: "Date",
    type: "Type",
    severity: "Severity",
    hours: "Hours",
    detail: "Detail",
    actions: "Actions",
    dismiss: "Dismiss",
    reopen: "Reopen",
    show_resolved: "Show resolved",
    anomaly_dismiss_note: "Add a resolution note (optional)",
    anomaly_dismissed: "Anomaly dismissed",
    anomaly_reopened: "Anomaly reopened",
    no_anomalies: "No anomalies — all clean ✨",
    live_presence: "Live presence",
    in_office: "In office",
    on_break: "On break",
    wfh: "Working from home",
    absent: "Absent / Out",
    on_leave: "On leave",
    total_employees: "Total employees",
    today_events: "Today's events",
    tap_badge: "Tap your badge to continue",
    manual_entry: "Enter badge ID manually",
    arrive: "Arrive",
    leave_office: "Leave",
    lunch_start: "Lunch start",
    lunch_end: "Lunch end",
    coffee: "Coffee break",
    coffee_end: "Coffee end",
    cigarette: "Cigarette break",
    cigarette_end: "Cigarette end",
    business_trip: "Business trip",
    business_trip_end: "Trip end",
    wfh_start: "WFH start",
    wfh_end: "WFH end",
    compensation_leave: "Compensation exit",
    welcome: "Welcome",
    goodbye: "See you next time",
    kiosk_unlock: "Kiosk setup",
    kiosk_key: "Kiosk API key",
    unlock: "Unlock kiosk",
    scan_badge: "Scan your badge",
    submit: "Submit",
    cancel: "Cancel",
    approve: "Approve",
    reject: "Reject",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cancelled: "Cancelled",
    request_leave: "Request leave",
    leave_type: "Leave type",
    start_date: "Start date",
    end_date: "End date",
    days: "Days",
    reason: "Reason",
    balance: "Vacation balance",
    export_csv: "Export CSV",
    month: "Month",
    year: "Year",
    work_hours: "Work hours",
    break_hours: "Break hours",
    events: "Events",
    name: "Name",
    role: "Role",
    team: "Team",
    badge: "Badge (NFC UID)",
    active: "Active",
    add_employee: "Add employee",
    edit: "Edit",
    delete: "Delete",
    no_data: "No data yet",
    annual: "Annual leave",
    sick: "Sick leave",
    unpaid: "Unpaid leave",
    wfh_short: "WFH",
    extraordinary: "Extraordinary leave (IZR)",
    compensatory: "Compensatory leave (KD)",
    blood_donation: "Blood donation (DAR)",
    escort: "Escort / family care (SPR)",
    overtime: "Overtime",
    time_correction: "Time correction",
    forgot_password: "Forgot password?",
    forgot_pw_title: "Reset password",
    forgot_pw_hint: "Enter your work email. We'll send a reset link if the account exists.",
    forgot_pw_submit: "Send reset link",
    forgot_pw_sent: "If an account with that email exists, a reset link has been sent. Check your inbox (and spam).",
    back_to_login: "Back to sign in",
    reset_pw_title: "Set new password",
    reset_pw_hint: "Choose a password with at least 8 characters.",
    reset_pw_new: "New password",
    reset_pw_confirm: "Confirm password",
    reset_pw_submit: "Save new password",
    reset_pw_success: "Password updated. Redirecting to sign in…",
    reset_pw_min: "Password must be at least 8 characters.",
    reset_pw_mismatch: "Passwords do not match.",
    reset_pw_no_token: "Missing reset token. Request a new reset link.",
    employee: "Employee",
    manager: "Manager",
    hr: "HR",
    admin: "Admin",
    action: "Action",
    time: "Time",
    type: "Type",
    status: "Status",
    last_event: "Last event",
    save: "Save",
    manage_hr: "Manage workforce. Approve, review, report.",
    login_hint: "Authorised personnel only. Kiosk is available at /kiosk.",
    brand_line: "Attendance + Leave control",
    hour_balance_month: "Hour balance (month)",
    hour_balance_ytd: "Hour balance (YTD)",
    obligation: "Obligation",
    worked: "Worked",
    obligation_vs_worked: "Obligation vs worked",
    daily_breakdown: "Daily breakdown",
    event_mix: "Event mix",
    vacation_current_year: "Vacation · this year",
    vacation_prior_year: "Vacation · last year (carry)",
    total_balance: "Total",
    enroll_card: "Enroll card",
    tap_new_card: "Tap the new card on the kiosk",
    expires_in: "Expires in",
    card_linked: "Card linked!",
    enroll_expired: "Enrollment expired",
    enroll_cancelled: "Enrollment cancelled",
    current_card: "Current card",
    retry: "Retry",
  },
  sl: {
    app_name: "ATTENDIO",
    tagline: "Prisotnost · Dopusti · Poročila",
    login: "Prijava",
    logout: "Odjava",
    email: "E-pošta",
    password: "Geslo",
    sign_in: "Prijavi se",
    dashboard: "Nadzorna plošča",
    kiosk: "Kiosk",
    attendance: "Moja prisotnost",
    my_status: "Moje stanje",
    monitor: "Monitor",
    leave: "Dopusti",
    approvals: "Odobritve",
    employees: "Zaposleni",
    reports: "Poročila",
    audit: "Revizijski dnevnik",
    settings: "Nastavitve",
    monthly_card: "Mesečni karton",
    monthly_card_title: "Mesečni karton",
    anomalies: "Anomalije",
    anomalies_title: "Anomalije",
    mc_total: "Skupaj",
    mc_flags: "Opozorila",
    mc_download_all: "Prenesi vse (PDF)",
    mc_download_single: "Prenesi PDF za zaposlenega",
    mc_hint_click_cell: "Klikni celico za urejanje dneva",
    mc_group_entry: "Skupinski vnos",
    mc_group_title: "Množični vnos ur ali dopusta",
    mc_group_targets: "Ciljni zaposleni",
    mc_group_apply: "Uporabi za izbrane",
    mc_group_applied: "Dni vneseno",
    mc_group_pick_target: "Izberi skupino ali vsaj enega zaposlenega",
    mc_whole_team_hint: "Vneseno bo za celotno skupino (brez posameznega izbora)",
    mc_include_weekends: "Vključi tudi vikende in praznike",
    mc_edit_day: "Uredi dan",
    mc_worked_h: "Delo (h)",
    mc_clear_override: "Odstrani ročni vnos",
    mc_saved: "Shranjeno",
    mc_override_tag: "Ročni vnos",
    mc_edit_times: "Vnesi prihod/odhod (HH:MM)",
    mc_edit_times_hint: "Izpolni oba za pravi časovni vnos. Prepiše vnos ur spodaj.",
    mc_edit_or_hours: "— ali samo število ur —",
    prihod: "Prihod",
    odhod: "Odhod",
    mode_desktop_label: "V pisarni",
    mode_kiosk_label: "Vhodni tablet",
    mode_pwa_label: "Telefon",
    app_mode: "Način naprave",
    app_mode_pick: "Izberi način",
    mode_pwa_install: "Namesti Attendio na začetni zaslon",
    mode_pwa_installed_or_unsupported: "Že nameščeno ali brskalnik ne podpira namestitve",
    mode_pwa_fallback_hint: "iPhone / Safari: tapnite ikono Deli, nato 'Dodaj na začetni zaslon'. Android / Chrome: tapnite ⋮, nato 'Namesti aplikacijo' ali 'Dodaj na začetni zaslon'.",
    all_teams: "Vse skupine",
    note: "Opomba",
    start_date: "Od datuma",
    end_date: "Do datuma",
    select_all: "Izberi vse",
    deselect_all: "Prekliči izbiro",
    selected: "izbranih",
    emp_reset_email_tip: "Pošlji e-pošto za ponastavitev gesla",
    emp_reset_temp_tip: "Generiraj začasno geslo",
    emp_reset_email_confirm: "Pošljem e-pošto za ponastavitev gesla temu zaposlenemu?",
    emp_reset_email_sent: "E-pošta poslana",
    emp_reset_link_generated: "Povezava za ponastavitev generirana (pošiljanje onemogočeno)",
    emp_reset_temp_confirm: "Generiram začasno geslo za tega zaposlenega?",
    emp_temp_password_title: "Začasno geslo",
    emp_temp_password_hint: "Kopiraj in posreduj zaposlenemu. S tem geslom se lahko takoj prijavi.",
    legend: "Legenda",
    office: "Pisarna",
    anomaly: "Anomalija",
    employee: "Zaposleni",
    date: "Datum",
    type: "Tip",
    severity: "Resnost",
    hours: "Ure",
    detail: "Opis",
    actions: "Akcije",
    dismiss: "Zaključi",
    reopen: "Odpri znova",
    show_resolved: "Prikaži zaključene",
    anomaly_dismiss_note: "Dodajte opombo (neobvezno)",
    anomaly_dismissed: "Anomalija zaključena",
    anomaly_reopened: "Anomalija ponovno odprta",
    no_anomalies: "Ni anomalij — vse je v redu ✨",
    live_presence: "Trenutna prisotnost",
    in_office: "V pisarni",
    on_break: "Na odmoru",
    wfh: "Delo od doma",
    absent: "Odsoten",
    on_leave: "Na dopustu",
    total_employees: "Vsi zaposleni",
    today_events: "Današnji dogodki",
    tap_badge: "Prisloni kartico za nadaljevanje",
    manual_entry: "Ročni vnos številke kartice",
    arrive: "Prihod",
    leave_office: "Odhod",
    lunch_start: "Začetek kosila",
    lunch_end: "Konec kosila",
    coffee: "Odmor za kavo",
    coffee_end: "Konec kave",
    cigarette: "Odmor (kajenje)",
    cigarette_end: "Konec odmora",
    business_trip: "Službeno pot",
    business_trip_end: "Konec poti",
    wfh_start: "Začetek dela od doma",
    wfh_end: "Konec dela od doma",
    compensation_leave: "Kompenzacijski izhod",
    welcome: "Dobrodošli",
    goodbye: "Se vidimo",
    kiosk_unlock: "Nastavitev kioska",
    kiosk_key: "API ključ kioska",
    unlock: "Odkleni kiosk",
    scan_badge: "Skeniraj kartico",
    submit: "Potrdi",
    cancel: "Prekliči",
    approve: "Odobri",
    reject: "Zavrni",
    pending: "V obravnavi",
    approved: "Odobreno",
    rejected: "Zavrnjeno",
    cancelled: "Preklicano",
    request_leave: "Zahtevek za dopust",
    leave_type: "Vrsta dopusta",
    start_date: "Začetek",
    end_date: "Konec",
    days: "Dni",
    reason: "Razlog",
    balance: "Stanje dopusta",
    export_csv: "Izvozi CSV",
    month: "Mesec",
    year: "Leto",
    work_hours: "Delovne ure",
    break_hours: "Odmori",
    events: "Dogodki",
    name: "Ime",
    role: "Vloga",
    team: "Ekipa",
    badge: "Kartica (NFC UID)",
    active: "Aktiven",
    add_employee: "Dodaj zaposlenega",
    edit: "Uredi",
    delete: "Izbriši",
    no_data: "Ni podatkov",
    annual: "Letni dopust",
    sick: "Bolniška",
    unpaid: "Neplačani dopust",
    wfh_short: "Delo od doma",
    extraordinary: "Izredni dopust (IZR)",
    compensatory: "Kompenzacijski dopust (KD)",
    blood_donation: "Krvodajalstvo (DAR)",
    escort: "Spremstvo (SPR)",
    overtime: "Nadure",
    time_correction: "Popravek časa",
    forgot_password: "Pozabljeno geslo?",
    forgot_pw_title: "Ponastavi geslo",
    forgot_pw_hint: "Vnesite službeni e-naslov. Če račun obstaja, bomo poslali povezavo za ponastavitev.",
    forgot_pw_submit: "Pošlji povezavo",
    forgot_pw_sent: "Če račun s tem e-naslovom obstaja, smo poslali povezavo za ponastavitev. Preverite nabiralnik (in vsiljeno pošto).",
    back_to_login: "Nazaj na prijavo",
    reset_pw_title: "Novo geslo",
    reset_pw_hint: "Izberite geslo z vsaj 8 znaki.",
    reset_pw_new: "Novo geslo",
    reset_pw_confirm: "Potrdite geslo",
    reset_pw_submit: "Shrani novo geslo",
    reset_pw_success: "Geslo je bilo posodobljeno. Preusmerjam na prijavo…",
    reset_pw_min: "Geslo mora imeti vsaj 8 znakov.",
    reset_pw_mismatch: "Gesli se ne ujemata.",
    reset_pw_no_token: "Manjka žeton za ponastavitev. Zahtevajte novo povezavo.",
    employee: "Zaposleni",
    manager: "Vodja",
    hr: "Kadri",
    admin: "Administrator",
    action: "Dejanje",
    time: "Čas",
    type: "Vrsta",
    status: "Status",
    last_event: "Zadnji dogodek",
    save: "Shrani",
    manage_hr: "Upravljajte s kadri. Odobrite, preglejte, poročajte.",
    login_hint: "Samo za pooblaščeno osebje. Kiosk je dostopen na /kiosk.",
    brand_line: "Prisotnost + nadzor dopustov",
    hour_balance_month: "Stanje ur (mesec)",
    hour_balance_ytd: "Stanje ur (letno)",
    obligation: "Obveznost",
    worked: "Oddelano",
    obligation_vs_worked: "Obveznost proti oddelanemu",
    daily_breakdown: "Stanje po dnevih",
    event_mix: "Pregled dogodkov",
    vacation_current_year: "Dopust · letošnji",
    vacation_prior_year: "Dopust · lanski (preneseno)",
    total_balance: "Skupaj",
    enroll_card: "Prijava kartice",
    tap_new_card: "Prisloni novo kartico na kiosk",
    expires_in: "Poteče čez",
    card_linked: "Kartica prijavljena!",
    enroll_expired: "Prijava je potekla",
    enroll_cancelled: "Prijava preklicana",
    current_card: "Trenutna kartica",
    retry: "Poskusi znova",
  },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("attendio_lang") || "en");

  useEffect(() => {
    localStorage.setItem("attendio_lang", lang);
  }, [lang]);

  const t = (key) => dict[lang]?.[key] || dict.en[key] || key;

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}

export function LangSwitch({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex brut-border ${className}`} data-testid="lang-switch">
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1 text-xs font-bold uppercase tracking-wider ${lang === "en" ? "bg-black text-white" : "bg-white text-black"}`}
      >
        EN
      </button>
      <button
        data-testid="lang-sl"
        onClick={() => setLang("sl")}
        className={`px-3 py-1 text-xs font-bold uppercase tracking-wider border-l-2 border-black ${lang === "sl" ? "bg-black text-white" : "bg-white text-black"}`}
      >
        SL
      </button>
    </div>
  );
}
